import React, { useEffect, useState } from "react";
import { get_list, listReview } from "../../../api/services";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { toggleForm } from "../../../redux/features/general";
import { useNavigate } from "react-router-dom";
import config from "../../../config.json";

const Table = ({ search }) => {
  const BaseUrl = config.dev ? config.localURLFrontEnd : config.liveURL;
  const [meta, setMeta] = useState({ ...initialMeta, search });
  const [list, setList] = useState([]);
  const [totalPages, setTotalPages] = useState(1); // Track total pages
  const { refresh } = useSelector((state) => state.general);
  const dispatch = useDispatch();
  useEffect(() => {
    fetchBlog();
  }, [meta.page, refresh, search]);

  async function fetchBlog() {
    try {
      const res = await listReview({ ...meta, search });

      console.log(res);

      if (res.status === 200) {
        const { reviews: fetchedList, total, numberOfPage, limit } = res.data; // Ensure `total` is returned from the API
        setList(fetchedList); // Update the current page's list
        setTotalPages(Math.floor(total / meta.limit)); // Calculate total pages
      } else {
        toast.success("Looks like all reviews have been fetched.");
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong!");
    }
  }

  const handlePageChange = (newPage) => {
    // Ensure the page is within valid bounds
    if (newPage >= 0 && newPage <= totalPages) {
      setMeta((old) => ({ ...old, page: newPage }));
    }
  };

  const th = [
    "Id",
    "Email",
    "Name",
    "Comment",
    "Course Id",
    "Status",
    "Date",
    "Action",
  ];

  return (
    <div>
      <div className="overflow-x-auto">
        <table className="min-w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-200 text-left">
              {th.map((header, index) => (
                <th key={index} className="px-4 py-2 border border-gray-300">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {list.map((item, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="px-4 py-2 border border-gray-300">
                  {item.review_id}
                </td>
                <td className="px-4 py-2 border border-gray-300">
                  {item.email}
                </td>
                <td className="px-4 py-2 border border-gray-300">
                  {item.userName}
                </td>
                <td className="px-4 py-2 border border-gray-300">
                  {item.comment}
                </td>
                <td className="px-4 py-2 border border-gray-300">
                  {item.course_id}
                </td>
                <td className="px-4 py-2 border border-gray-300">
                  {item.status}
                </td>
                <td className="px-4 py-2 border border-gray-300">
                  {new Date(item.created_at).toLocaleString()}
                </td>
                <td className="px-4 py-2 border flex items-center justify-center border-gray-300">
                  <div className="flex gap-4 ">
                    {/* preview */}
                    <button
                      onClick={() =>
                        dispatch(
                          toggleForm({
                            form: "review_status",
                            slug: item.review_id,
                            data: { ...item },
                          })
                        )
                      }
                      className="group hover:bg-white bg-primary border border-primary p-1 rounded-lg"
                    >
                      <svg
                        className="fill-white group-hover:fill-primary"
                        width={25}
                        height={20}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        <title>eye-outline</title>
                        <path d="M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z" />
                      </svg>
                    </button>
                    {/* preview blogs */}
                    <button
                      onClick={() =>
                        (window.location.href = `${BaseUrl}/courseByID/${item.course_id}`)
                      }
                      className="group hover:bg-white bg-primary border border-primary p-1 rounded-lg"
                    >
                      <svg
                        className="fill-white group-hover:fill-primary"
                        width={25}
                        height={20}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        <title>book-open-blank-variant</title>
                        <path d="M6.5 20C8.2 20 10.65 20.65 12 21.5C13.35 20.65 15.8 20 17.5 20C19.15 20 20.85 20.3 22.25 21.05C22.35 21.1 22.4 21.1 22.5 21.1C22.75 21.1 23 20.85 23 20.6V6C22.4 5.55 21.75 5.25 21 5C19.89 4.65 18.67 4.5 17.5 4.5C15.55 4.5 13.45 4.9 12 6C10.55 4.9 8.45 4.5 6.5 4.5C5.33 4.5 4.11 4.65 3 5C2.25 5.25 1.6 5.55 1 6V20.6C1 20.85 1.25 21.1 1.5 21.1C1.6 21.1 1.65 21.1 1.75 21.05C3.15 20.3 4.85 20 6.5 20M12 19.5V8C13.35 7.15 15.8 6.5 17.5 6.5C18.7 6.5 19.9 6.65 21 7V18.5C19.9 18.15 18.7 18 17.5 18C15.8 18 13.35 18.65 12 19.5Z" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center mt-4">
        <button
          onClick={() => handlePageChange(meta.page - 1)}
          disabled={meta.page <= 0}
          className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-primary group hover:scale-90 transition-all disabled:opacity-50 disabled:pointer-events-none"
        >
          <svg
            width={30}
            height={30}
            className="group-hover:fill-white"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <title>chevron-left</title>
            <path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
          </svg>
        </button>
        <span>Page {meta.page + 1}</span>
        <button
          disabled={totalPages <= meta.page}
          onClick={() => handlePageChange(meta.page + 1)}
          className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-primary group hover:scale-90 transition-all disabled:opacity-50 disabled:pointer-events-none"
        >
          <svg
            width={30}
            height={30}
            className="group-hover:fill-white"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <title>chevron-right</title>
            <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
          </svg>
        </button>
      </div>
    </div>
  );
};

const initialMeta = {
  page: 0, // Start with page 1
  limit: 5, // Items per page
  listAll: true,
};

export default Table;
